export default "__VITE_ASSET__cd3c97f7__"